module.exports = __webpack_public_path__ + "static/media/02.f5c86072.png";